/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ideal_Left_Hyena_EarnInputs */

const es_ideal_left_hyena_earn = /** @type {(inputs: Ideal_Left_Hyena_EarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aun no tienes una cuenta?`)
};

const gl_ideal_left_hyena_earn = /** @type {(inputs: Ideal_Left_Hyena_EarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aínda non tes unha conta?`)
};

const en_ideal_left_hyena_earn = /** @type {(inputs: Ideal_Left_Hyena_EarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't have an account yet?`)
};

/**
* | output |
* | --- |
* | "Don't have an account yet?" |
*
* @param {Ideal_Left_Hyena_EarnInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ideal_left_hyena_earn = /** @type {((inputs?: Ideal_Left_Hyena_EarnInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ideal_Left_Hyena_EarnInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ideal_left_hyena_earn(inputs)
	if (locale === "en") return en_ideal_left_hyena_earn(inputs)
	return es_ideal_left_hyena_earn(inputs)
});